import { Box, Flex, Text } from "rebass/styled-components";

import {
  StyledMobileAppPromo,
  AppButton,
  AppButtonText,
  StyledAppleIcon,
  StyledGooglePlayIcon,
  MobileLogo,
} from "./styledComponents";
import mobileImage from "../../../Assets/mobile.png";
import { analytics } from "MVVM/Analytics";

const MobileAppPromo = () => {
  const iosUrl = "https://apps.apple.com/us/app/allstar-gg/id6476161266";
  const androidUrl =
    "https://play.google.com/store/apps/details?id=com.androidapp.gg.allstar";

  return (
    <StyledMobileAppPromo>
      <Flex alignItems="center" my={4} style={{ gap: 4 }}>
        <MobileLogo src={mobileImage} alt="Allstar Mobile" />
        <Box ml={2}>
          <Text fontSize={0} fontWeight={500} color="chalk" mb={1}>
            Clip Anywhere, Anytime.
          </Text>
          <Text fontSize={2} fontWeight={600} color="ice">
            Get The Mobile App
          </Text>
        </Box>
      </Flex>
      <Flex style={{ gap: 8 }}>
        <AppButton
          onClick={() => {
            analytics.track("Button - Click", {
              location: "sidebar",
              locationIdentifier: "mobileAppDownload_iOS",
            });
            window.open(iosUrl, "_blank");
          }}
          style={{ maxWidth: 80 }}
        >
          <StyledAppleIcon />
          <AppButtonText>iOS</AppButtonText>
        </AppButton>
        <AppButton
          onClick={() => {
            analytics.track("Button - Click", {
              location: "sidebar",
              locationIdentifier: "mobileAppDownload_Android",
            });
            window.open(androidUrl, "_blank");
          }}
          style={{ maxWidth: 90 }}
        >
          <StyledGooglePlayIcon />
          <AppButtonText>Android</AppButtonText>
        </AppButton>
      </Flex>
    </StyledMobileAppPromo>
  );
};

export { MobileAppPromo };
